module.exports = __webpack_public_path__ + "static/linguamillDesktopBig@2x-4a85b519e7d8d312c0e48e2e803d68be.jpg";